import React from 'react';

import { YoutubeOutlined, InstagramOutlined, FacebookFilled } from '@ant-design/icons';
import { FaTiktok } from 'react-icons/fa';
import { FiGlobe } from 'react-icons/fi';
import { MdOutlineMonitor } from 'react-icons/md';

export const getIconsForResolution = (res: string) => {
  const iconStyle = { fontSize: 15 };
  const icons: React.ReactNode[] = [];

  if (['300x250', '300x600', '310x482', '400x600'].includes(res)) {
    icons.push(<FiGlobe key='globe' style={{ ...iconStyle, color: '#6B7280' }} />);
  }

  if (res === '1080x1920') {
    icons.push(
      <InstagramOutlined key='ig' style={{ ...iconStyle, color: '#E1306C' }} />,
      <FacebookFilled key='fb' style={{ ...iconStyle, color: '#1877F2' }} />,
      <YoutubeOutlined key='yt' style={{ ...iconStyle, color: '#FF0000' }} />,
      <FaTiktok key='tiktok' style={{ ...iconStyle, fontSize: '13px', color: '#000000' }} />
    );
  }

  if (['1080x1080', '1080x1350'].includes(res)) {
    icons.push(
      <InstagramOutlined key={`ig-${res}`} style={{ ...iconStyle, color: '#E1306C' }} />,
      <FacebookFilled key={`fb-${res}`} style={{ ...iconStyle, color: '#1877F2' }} />
    );
  }

  if (res === '1920x1080') {
    icons.push(
      <FacebookFilled key='fb' style={{ ...iconStyle, color: '#1877F2' }} />,
      <YoutubeOutlined key='yt' style={{ ...iconStyle, color: '#FF0000' }} />,
      <MdOutlineMonitor key='dooh' style={{ ...iconStyle, color: '#6B7280' }} />
    );
  }

  return icons;
};
